import React, { useRef } from 'react'

import Editor from '@draft-js-plugins/editor'

import createToolbarPlugin, { Separator } from '@draft-js-plugins/static-toolbar'
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  UnorderedListButton,
  OrderedListButton,
  SubButton,
  SupButton
} from '@draft-js-plugins/buttons'

import HeadlinesButton from './HeadlinesButton'

import editorStyles from './editor.module.css'

import '@draft-js-plugins/static-toolbar/lib/plugin.css'

const toolbarPlugin = createToolbarPlugin()
const { Toolbar } = toolbarPlugin
const plugins = [toolbarPlugin]

const WYSIWYG = ({ state, setState }) => {
  const editor = useRef(null)

  const handleOnChange = e => {
    setState(e)
  }

  return (
    <div>
      <div className={editorStyles.editor}>
        <Editor
          editorState={state}
          onChange={handleOnChange}
          plugins={plugins}
          ref={editor}
          customStyleMap={{
            SUBSCRIPT: { fontSize: '0.6em', verticalAlign: 'sub' },
            SUPERSCRIPT: { fontSize: '0.6em', verticalAlign: 'super' }
          }}
        />
        <Toolbar>
          {// may be use React.Fragment instead of div to improve perfomance after React 16
          externalProps => (
            <div>
              <HeadlinesButton {...externalProps} />
              <BoldButton {...externalProps} />
              <ItalicButton {...externalProps} />
              <UnderlineButton {...externalProps} />
              <Separator {...externalProps} />
              <SubButton {...externalProps} />
              <SupButton {...externalProps} />
              <Separator {...externalProps} />
              <UnorderedListButton {...externalProps} />
              <OrderedListButton {...externalProps} />
            </div>
          )}
        </Toolbar>
      </div>
    </div>
  )
}

export default WYSIWYG
